const AutoTable = ({ data, title }: any) => {
    const entries = Object.entries(data);
    const rowKeys = Object.keys(entries[0][1] || {});

    return (
        <div className=" flex flex-col items-center gap-2 w-full">
            <h2 className="text-black text-center font-extrabold max-w-4xl text-xl lg:text-2xl font-nunito">{title}</h2>
            <table className="w-full border-2 border-white">
                <thead className="bg-[#4A731F] text-white">
                    <tr>
                        <th className="p-2 border-2 border-white bg-[#4A731F]">
                            Name
                        </th>
                        {rowKeys.map((key) => (
                            <th
                                key={key}
                                className="p-2 border-2 border-white bg-[#4A731F] capitalize"
                            >
                                {key.replace(/_/g, " ")}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {entries.map(([name, values]: any) => (
                        <tr key={name}>
                            <td className="p-2 border-2 border-white bg-[#D6FFAB] font-semibold capitalize">
                                {name.replace(/_/g, " ")}
                            </td>

                            {rowKeys.map((col) => (
                                <td
                                    key={col}
                                    className="p-2 border-2 border-white text-center bg-[#FFF7CE]"
                                >
                                    {values[col]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AutoTable;
